const BUSINESS_ACCOUNT_RANDOM_DIGITS = 10;
const BUSINESS_ACCOUNT_TOTAL_DIGITS = 11;

function randomDigit() {
  const cryptoObject = globalThis.crypto;

  if (cryptoObject?.getRandomValues) {
    const array = new Uint8Array(1);
    cryptoObject.getRandomValues(array);
    return array[0] % 10;
  }

  return Math.floor(Math.random() * 10);
}

export function normalizeBusinessAccountNumber(value: unknown) {
  if (typeof value !== "string") return "";

  return value.replace(/\D/g, "");
}

export function calculateBusinessAccountCheckDigit(firstTenDigits: string) {
  const body = normalizeBusinessAccountNumber(firstTenDigits);

  if (body.length !== BUSINESS_ACCOUNT_RANDOM_DIGITS) {
    throw new Error("Account number body must be exactly 10 digits.");
  }

  let sum = 0;
  let shouldDouble = true;

  for (let index = body.length - 1; index >= 0; index -= 1) {
    let digit = Number(body[index]);

    if (shouldDouble) {
      digit *= 2;

      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return String((10 - (sum % 10)) % 10);
}

export function generateBusinessAccountNumber() {
  let body = "";

  for (let index = 0; index < BUSINESS_ACCOUNT_RANDOM_DIGITS; index += 1) {
    body += String(randomDigit());
  }

  return `${body}${calculateBusinessAccountCheckDigit(body)}`;
}

export function isValidBusinessAccountNumber(value: unknown) {
  const accountNumber = normalizeBusinessAccountNumber(value);

  if (accountNumber.length !== BUSINESS_ACCOUNT_TOTAL_DIGITS) {
    return false;
  }

  const body = accountNumber.slice(0, BUSINESS_ACCOUNT_RANDOM_DIGITS);
  const checkDigit = accountNumber.slice(-1);

  return calculateBusinessAccountCheckDigit(body) === checkDigit;
}